import Icon from "@react-native-vector-icons/material-design-icons/static";
import { useTranslation } from "react-i18next";
import { Text, TouchableRipple } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";
import Button from "../Button";

type Props = {
	onSupportContact: () => void;
	onLoginRetry: () => void;
};

const VerificationLinkExpired = ({ onSupportContact, onLoginRetry }: Props) => {
	const { t } = useTranslation();
	const theme = useAppTheme();

	return (
		<Box
			id="verify-expired-view"
			justifyContent="center"
			alignItems="center"
			gap={24}
			flex={1}
		>
			<Icon
				name="alert-circle-outline"
				size={120}
				color={theme.colors.primary}
			/>
			<Box gap={8} alignItems="center">
				<Text variant="titleLarge">
					{t("auth.verify.verificationLinkExpired")}
				</Text>
				<Text variant="bodyLarge" style={{ textAlign: "center" }}>
					{t("auth.verify.verificationLinkExpiredBody")}
				</Text>
			</Box>
			<Button
				testID="verify-expired-login-button"
				mode="contained"
				onPress={onLoginRetry}
			>
				{t("auth.verify.loginAgain")}
			</Button>
			<TouchableRipple onPress={onSupportContact} style={{ padding: 16 }}>
				<Text style={{ color: theme.colors.secondary }}>
					{t("auth.verify.contactSupportExpiredLink")}
				</Text>
			</TouchableRipple>
		</Box>
	);
};

export default VerificationLinkExpired;
